import React from "react";
import Spotify from "./logos/spotify.svg";
import Deezer from "./logos/deezer.svg";
import SoundCloud from "./logos/sound-cloud.svg";
import AmazonMusic from "./logos/amazon-music.svg";
import "./style.css";

export const PlatformsSlide = ({ className }) => {
  const streamingLogos = [
    { logo: Spotify, link: "#" },
    { logo: Deezer, link: "#" },
    { logo: SoundCloud, link: "#" },
    { logo: AmazonMusic, link: "#" },
  ];

  // Duplicar os logos para criar efeito de loop infinito
  const duplicatedLogos = [
    ...streamingLogos,
    ...streamingLogos,
    ...streamingLogos,
  ];

  return (
    <div className="platforms-container detail-bottom">
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }

        .animate-scroll {
          animation: scroll 30s linear infinite;
          gap: 95px;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="platforms-container__list position-relative overflow-hidden">
        <div className="d-flex animate-scroll">
          {duplicatedLogos.map((item, index) => (
            <img key={index} src={item.logo} alt="" />
          ))}
        </div>
      </div>
    </div>
  );
};
